var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuotesReceived(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Quote",
    transform: "translate(-1214 -601)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19349",
    "data-name": "Rectangle 19349",
    width: 40,
    height: 40,
    transform: "translate(1214 601)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "noun-bill-4525321",
    d: "M188.525,35H177.387A2.386,2.386,0,0,0,175,37.387V55.075a1.591,1.591,0,0,0,2.41,1.365l1.161-.7a1.988,1.988,0,0,1,2.228.115,3.61,3.61,0,0,0,4.31,0,1.994,1.994,0,0,1,2.228-.115l1.161.7a1.591,1.591,0,0,0,2.415-1.365V37.387A2.386,2.386,0,0,0,188.525,35Zm.376,15.116H177.153a.8.8,0,1,1,0-1.591H188.9a.8.8,0,1,1,0,1.591Zm0-3.182H177.153a.8.8,0,1,1,0-1.591H188.9a.8.8,0,1,1,0,1.591Zm0-3.182H177.153a.8.8,0,1,1,0-1.591H188.9a.8.8,0,1,1,0,1.591Zm0-3.182H177.153a.8.8,0,1,1,0-1.591H188.9a.8.8,0,1,1,0,1.591Z",
    transform: "translate(1051.045 575.166)",
    fill: "#527e3c"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotesReceived);
export default __webpack_public_path__ + "static/media/quotesReceived.a6667a753ac7ee4f5d3dbf3fc3b7d080.svg";
export { ForwardRef as ReactComponent };